/* eslint-disable */
const CONSTANTS = {
  REGEX: {
    EMAIL: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    NAME: /^[A-Za-z\s]+$/,
    PLACE_OF_BIRTH: /^[A-Za-z\s]+$/,
    PHONE_NUMBER: /^\d{8,14}$/,
    SPECIAL_CHARACTERS: /^[A-Za-z0-9\.\-\s]+$/,
    SPECIAL_CHARACTERS_CERTIFICATIONS: /^[A-Za-z0-9\.\-\s,]+$/,
    SPECIAL_CHARACTERS_ADDRESS: /^[A-Za-z0-9\s\-\.\/,]+$/,
    LINKEDIN: /^https:\/\/www\.linkedin\.com.*/,
    URL: /https?:\/\/[\w\-]+(\.[\w\-]+)+[\w\-\.\?\=\&]*/,
    OTHERS: /^[A-Za-z0-9@ ]+$/,
    MOBILE_NUMBER: /^\+?\d{8,14}$/,
    BASE_64: /^data:image\/?[A-z]*;base64,/
  },
  SOCIALMEDIURLS: {
    facebook: "https://www.facebook.com/bliblidotcom",
    instagram: "https://www.instagram.com/lifeatblibli/",
    twitter: "https://twitter.com/bliblidotcom",
    linkedin: "https://www.linkedin.com/company/blibli/mycompany/?viewAsMember=true",
    youtube: "https://www.youtube.com/user/bliblidotcom"
  },
  LOCATION: {
    BANGALORE: 'Bangalore',
    COIMBATORE: 'Coimbatore'
  },
  OFFICE_DETAILS: {
    address: 'Gedung Sarana Jaya, Jl. Budi Kemuliaan No.I No.1, RT.2/RW.3, Gambir, Kecamatan Gambir, Kota Jakarta Pusat, Daerah Khusus Ibukota Jakarta 10110'
  },
  MONTHS_LIST: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
}

export default CONSTANTS
